module.exports = __webpack_public_path__ + "static/media/bell.717075a5.svg";